/**
 * Пересылка сообщений: POST /api/v1/accounts/:id/unia_forwards (наш UniaForwardsController,
 * _vendor/chatwoot/_giper/FORWARD_MESSAGES.md). Тот же клиент и заголовки, что у остальных вызовов (cwFetch).
 * 422 приходит как ApiError с текстом сервера { error } — показываем как есть.
 */
import { cwFetch } from './chatwoot';
import type { ForwardRequest, ForwardResult } from '@/lib/forward';

export const forwardMessages = (accountId: number, body: ForwardRequest) =>
  cwFetch<ForwardResult>(`/api/v1/accounts/${accountId}/unia_forwards`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
